import React, { useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <div className="flex items-center space-x-2">
              <img 
                src="/logo-dms.png" 
                alt="DMS David Multi Service - Logo de l'entreprise de bricolage, jardinage et informatique à Elven" 
                className="h-20 w-auto object-contain"
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('accueil')}
              className="text-gray-700 hover:text-green-600 font-medium"
            >
              Accueil
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-green-600 font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('zones')}
              className="text-gray-700 hover:text-green-600 font-medium"
            >
              Zones
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-green-600 font-medium"
            >
              À propos
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-green-600 font-medium"
            >
              Contact
            </button>
            <a href="tel:0744921208">
              <Button className="bg-green-600 hover:bg-green-700 text-white">
                <Phone className="w-4 h-4 mr-2" />
                07 44 92 12 08
              </Button>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('accueil')}
                className="text-gray-700 hover:text-green-600 font-medium text-left"
              >
                Accueil
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-green-600 font-medium text-left"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('zones')}
                className="text-gray-700 hover:text-green-600 font-medium text-left"
              >
                Zones
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-green-600 font-medium text-left"
              >
                À propos
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-green-600 font-medium text-left"
              >
                Contact
              </button>
              <a href="tel:0744921208" className="w-full">
                <Button className="bg-green-600 hover:bg-green-700 text-white w-full">
                  <Phone className="w-4 h-4 mr-2" />
                  07 44 92 12 08
                </Button>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};